export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pyodide.worker.83bc5d0e.js");
}
